module.exports = __webpack_public_path__ + "static/media/OCEAN-FREIGHT.825b68ec.jpg";